<app-sidebar 
  [menuItems]="menuItems" 
  [callToAction]="callToAction"
  [footerItems]="footerItems"
  [headerLabel]="headerLabel">
</app-sidebar>



